/* eslint-disable */
// @ts-nocheck

import React from 'react'

import { ColumnDef } from '@tanstack/react-table'

import { Badge } from '@/components/ui/badge'
import { PurchaseOrder } from '@/interfaces/purchaseOrder'

// Función para formatear fecha con mes en letras
const formatDateWithMonth = (dateString: string): string => {
  if (!dateString) return ''

  const date = new Date(dateString)
  const months = [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ]

  const day = date.getDate()
  const month = months[date.getMonth()]
  const year = date.getFullYear()

  return `${day} ${month} ${year}`
}

const getOrderStatusBadge = (status: PurchaseOrder['orderStatus']) => {
  const variants = {
    draft: { label: 'Borrador', className: 'bg-gray-100 text-gray-800' },
    pending: { label: 'Pendiente', className: 'bg-yellow-100 text-yellow-800' },
    approved: { label: 'Aprobada', className: 'bg-green-100 text-green-800' },
    rejected: { label: 'Rechazada', className: 'bg-red-100 text-red-800' },
    completed: { label: 'Completada', className: 'bg-blue-100 text-blue-800' },
    cancelled: { label: 'Cancelada', className: 'bg-gray-100 text-gray-800' },
  }

  const variant = variants[status] || variants.draft
  return <Badge className={variant.className}>{variant.label}</Badge>
}

const getPaymentStatusBadge = (status: PurchaseOrder['paymentStatus']) => {
  const variants = {
    pending: { label: 'Pendiente', className: 'bg-yellow-100 text-yellow-800' },
    partial: { label: 'Parcial', className: 'bg-orange-100 text-orange-800' },
    paid: { label: 'Pagado', className: 'bg-green-100 text-green-800' },
    overdue: { label: 'Vencido', className: 'bg-red-100 text-red-800' },
  }

  const variant = variants[status] || variants.pending
  return <Badge className={variant.className}>{variant.label}</Badge>
}

export const getColumns = (): ColumnDef<PurchaseOrder>[] => [
  {
    accessorKey: 'client.name',
    header: 'Cliente',
    enableHiding: true,
    cell: ({ row }) => (
      <div className="font-medium">{row.original.client.name}</div>
    ),
  },
  {
    accessorKey: 'orderNumber',
    header: 'No. orden de compra',
    enableHiding: true,
    cell: ({ getValue }) => (
      <div className="font-mono text-sm">{getValue<string>()}</div>
    ),
  },
  {
    accessorKey: 'orderStatus',
    header: 'Estado de la orden',
    enableHiding: true,
    cell: ({ getValue }) =>
      getOrderStatusBadge(getValue<PurchaseOrder['orderStatus']>()),
  },
  {
    accessorKey: 'paymentStatus',
    header: 'Estado del pago',
    enableHiding: true,
    cell: ({ getValue }) =>
      getPaymentStatusBadge(getValue<PurchaseOrder['paymentStatus']>()),
  },
  {
    accessorKey: 'amount',
    header: 'Importe',
    enableHiding: true,
    cell: ({ getValue }) => (
      <div className="font-medium">
        $
        {getValue<number>().toLocaleString('es-ES', {
          minimumFractionDigits: 2,
        })}
      </div>
    ),
  },
  {
    accessorKey: 'totalProducts',
    header: 'Total de productos',
    enableHiding: true,
    cell: ({ getValue }) => (
      <div className="text-center">{getValue<number>()}</div>
    ),
  },
  {
    accessorKey: 'issueDate',
    header: 'Fecha de emisión',
    enableHiding: true,
    cell: ({ getValue }) => (
      <div className="text-sm">{formatDateWithMonth(getValue<string>())}</div>
    ),
  },
]
